import {http} from '@/utils/http';
import {sendException} from '@/modules/Monitoring';

interface FeatureFlagResponse {
  name: string;
  enabled: false;
}

export const getFeatureFlagsConfig = async (): Promise<FeatureFlagResponse[]> => {
  try {
    return await http.get<FeatureFlagResponse[]>(`/api/feature-flags`);
  } catch (e) {
    sendException(e as Error);
    return Promise.resolve([]);
  }
};
